import { createContext } from 'react'
import { SecretsModel } from '../../models/domain/secrets.model'

interface IDomainSecretsContext {
    loading: boolean
    domainId: number
    secret: SecretsModel
    setSecret: (changes: SecretsModel, debounce?: boolean) => any
}

export const DomainSecretsContext = createContext<IDomainSecretsContext>({} as IDomainSecretsContext)
